import type { RequestOptions } from "ls/api/common/server";
import type {
  LoginRequestModel,
  LoginTokenRequestModel,
  SendFeedbackModel,
  UserSessionResponse,
} from "./user.types";
import { objectToFormData } from "@/services/utils/formData";
import { server } from "./server";

export async function login(credentials: LoginRequestModel, { signal }: RequestOptions = {}) {
  const response = await server.post("user/login", credentials, { signal });
  return response.data as UserSessionResponse;
}

export async function loginToken(model: LoginTokenRequestModel, { signal }: RequestOptions = {}) {
  const response = await server.post("user/login-token", model, { signal });
  return response.data as UserSessionResponse;
}

export async function textServiceToken({ signal }: RequestOptions = {}) {
  const response = await server.post("user/text-service-token", undefined, { signal });
  return response.data as string;
}

export async function checkSession({ signal }: RequestOptions = {}) {
  const response = await server.post("user/check-session", undefined, { signal });
  return response.data as UserSessionResponse;
}

export async function logout() {
  await server.post("user/logout", undefined);
}

export function sendFeedback(model: SendFeedbackModel, { signal }: RequestOptions = {}) {
  const formData = objectToFormData(model);
  return server.post("user/send-feedback", formData, { signal });
}
